var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],tag:"component",staticClass:"button",class:[
    _vm.typeClass,
    _vm.sizeClass,
    {
      button_loading: _vm.loading,
      button_disabled: _vm.disabled
    }
  ]},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('loader',{attrs:{"size":"15px","border":"3px","type":_vm.loaderType,"absolute":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }